export { STEPPER_STEPS, DEFAULT_PROGRESS_PERCENT } from './StepperData';
export { default as StepperArrow } from './StepperArrow';
export { default as StepperChips } from './StepperChips';
export { default as StepperProgress } from './StepperProgress';
export { default as StepperCProgress } from './StepperCProgress';

// Aliases for existing UI barrel naming
export { default as Progress } from './StepperProgress';
export { default as CProgress } from './StepperCProgress';
